import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import Tags from "../../form/Tags";

class pageForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput name="pagetype" value={this.props.values.pagetype} label="Név"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("pagetype")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Tags
                            name="title"
                            value={this.props.values.title}
                            label="Cím"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("title")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextInput name="description" value={this.props.values.description} label="Leírás"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("description")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextInput name="image" value={this.props.values.image} label="Kép"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("image")}/>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(pageForm);
